<div class="auth-layout">
  <!-- Left hero panel -->
  <section class="left-panel">
    <div class="lockup">
      <h1 class="logo-text">Stitch</h1>
      <div class="byline">
        <span class="by-word">by</span>
        <img class="lilo-logo" src="/images/lilo-logo.svg" alt="lilo social" />
      </div>
    </div>
    <h2 class="headline">
      <span>All your data questions,</span>
      <br />
      <span>answered</span><span class="accent-dot"></span>
    </h2>
    <div #dotsHost class="dots">
      <svg class="dots-svg" [attr.width]="dotsWidth" [attr.height]="dotsHeight" [attr.viewBox]="'0 0 ' + dotsWidth + ' ' + dotsHeight" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" preserveAspectRatio="xMinYMax meet">
        <defs>
          <!-- Figma-like radial fade mask (center-strong, edges-fade) -->
          <radialGradient id="dotsFadeGradient" cx="50%" cy="50%" r="50%">
            <stop offset="20.5%" stop-color="#ffffff" stop-opacity="1" />
            <stop offset="100%" stop-color="#ffffff" stop-opacity="0.1" />
          </radialGradient>
          <mask id="dotsMask" maskUnits="objectBoundingBox" maskContentUnits="objectBoundingBox">
            <rect x="0" y="0" width="1" height="1" fill="url(#dotsFadeGradient)" opacity="0.3" />
          </mask>
        </defs>
        <g mask="url(#dotsMask)">
          <ng-container *ngFor="let d of dotCircles">
            <circle [attr.cx]="d.cx" [attr.cy]="d.cy" [attr.r]="dotRadius" fill="#ffffff" />
          </ng-container>
        </g>
      </svg>
    </div>
  </section>

  <!-- Right auth panel -->
  <section class="right-panel">
    <!-- Mobile lockup (shown only on small screens) -->
    <div class="mobile-lockup">
      <div class="lockup">
        <h1 class="logo-text">Stitch</h1>
        <div class="byline">
          <span class="by-word">by</span>
          <img class="lilo-logo" src="/images/lilo-logo.svg" alt="lilo social" />
        </div>
      </div>
    </div>

    <!-- Email step -->
    <div *ngIf="currentStep === 'email'" class="card-step">
      <form [formGroup]="emailForm" (ngSubmit)="onEmailSubmit()" class="form-vertical">
        <label class="field-label">Register or Login</label>
        <input
        style="margin-bottom: 25px;"
          type="email"
          formControlName="email"
          class="field-input"
          placeholder="example@domain.com"
          [class.invalid]="emailForm.get('email')?.invalid && emailForm.get('email')?.touched"
        />

        <div class="error-message" *ngIf="error">{{ error }}</div>

        <button type="submit" class="primary-btn" [disabled]="!emailForm.valid || loading">
          {{ loading ? 'PLEASE WAIT…' : 'Continue' }}
        </button>
      </form>
    </div>

    <!-- OTP step -->
    <div *ngIf="currentStep === 'otp'" class="card-step">
      <form [formGroup]="otpForm" (ngSubmit)="onOtpSubmit()" class="form-vertical">
        <label class="field-label">Enter code from email</label>
        <div class="otp-inputs-container">
          <input
            *ngFor="let digit of otpDigits; let i = index"
            type="text"
            class="otp-digit-input"
            [value]="digit"
            maxlength="1"
            (input)="onOtpDigitInput($event, i)"
            (keydown)="onOtpKeyDown($event, i)"
            (paste)="onOtpPaste($event, i)"
            #otpInput
            [class.error]="otpForm.get('otp')?.invalid && otpForm.get('otp')?.touched"
          />
        </div>

        <div class="error-message" *ngIf="error">{{ error }}</div>

        <button type="submit" class="primary-btn" [disabled]="!otpForm.valid || loading">
          {{ loading ? 'VERIFYING…' : 'Sign in' }}
        </button>

        <div class="resend-inline">
          <span>Didn't receive OTP?</span>
          <button type="button" (click)="resendOtp()" [disabled]="loading">Resend now</button>
        </div>
      </form>
    </div>
  </section>
</div>